module.exports = __webpack_public_path__ + "static/media/Dart.1ecfc727.png";